import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { db } from '../../../api/fire';
import AuthContext from '../../../context/AuthContext';
import Button from '../../shared/Button';
import Container from '../../shared/Container';
import Heading from '../../shared/Heading';
import MessageModal from './MessageModal';

const CardGrid = styled.div`
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  margin: 50px 0;
`;

const Card = styled.div`
  background: white;
  border-radius: 24px;
  color: ${(props) => props.theme.primary};
  padding: 20px;
  flex: 1;
  cursor: pointer;
  background: ${(props) => (props.isOpen ? 'red' : 'white')};
  position: relative;
`;

const Info = styled.div`
  display: flex;
  align-items: start;
  justify-content: space-between;
  h2 {
    width: 200px;
    margin: 0;
    padding: 0;
  }
  span {
    font-size: 18px;
  }
`;

const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    margin: 0;
  }
`;

const Messages = () => {
  const [messages, setMessages] = useState([]);
  const { signOut } = useContext(AuthContext);
  const [messageModal, setMessageModal] = useState('');

  useEffect(() => {
    const snapshot = db.collection('messages').onSnapshot((querySnapshot) => {
      const messagesArray = [];
      querySnapshot.forEach((doc) => {
        messagesArray.push({ id: doc.id, ...doc.data() });
      });
      setMessages(messagesArray);
    });
    return () => {
      snapshot();
    };
  }, []);

  const handleMessageDelete = (messageId) => {
    db.collection('messages')
      .doc(messageId)
      .delete()
      .then(() => {
        setMessageModal(null);
      })
      .catch((error) => {
        // console.log(error);
      });
  };

  const handleSignOut = () => {
    signOut();
  };

  const handleModalClose = () => {
    setMessageModal(null);
  };
  const handleModalOpen = (id) => {
    setMessageModal({ id });
  };
  return (
    <>
      <Container>
        <StyledHeader>
          <Heading>Messages</Heading>
          <Button secondary type="button" onClick={handleSignOut}>
            Log Out
          </Button>
        </StyledHeader>
        <CardGrid>
          {messages
            ? messages.map(({ id, message, contactNo, fullName }) => (
                <Card
                  key={id}
                  onClick={() => {
                    handleModalOpen(id);
                  }}
                >
                  <Info>
                    <h2>{fullName}</h2>
                    <span>{contactNo}</span>
                  </Info>
                  {message.length > 200 ? (
                    <p>{`${message.substring(0, 200)}...`}</p>
                  ) : (
                    <p>{message}</p>
                  )}
                </Card>
              ))
            : null}
        </CardGrid>
      </Container>
      {messageModal ? (
        <MessageModal
          id={messageModal.id}
          closeModal={handleModalClose}
          deleteMessage={handleMessageDelete}
        />
      ) : null}
    </>
  );
};

export default Messages;
